import React from 'react';
import withStyles from 'isomorphic-style-loader/withStyles';

import { Grid, Row, Col, Button } from 'react-bootstrap';

import s from './DISLandingPage.css';

import VariantSearch from '../../VariantSearch';
import Link from '../../Link';

import { STATIC_HOST_URL } from '../../../settings';

function DISLandingPage() {
  return (
    <div className={s.root}>
      <Grid fluid={false}>
        <Row>
          <Col md={12}>
            <div className={s.container}>
              <div
                className="text-center"
                style={{ width: '90%', margin: 'auto' }}
              >
                <h3 className={s.title}>
                  Whole-genome deep-learning analysis reveals causal role of
                  noncoding mutations in autism
                </h3>
                <p>
                  Explore the predicted effects of 127,140 autism proband
                  mutations from Simons Simplex Collection whole genome
                  sequencing data.
                </p>
                <p>
                  <Link to="/asdbrowser">View as genome browser</Link>
                </p>
                <div style={{ margin: '30px 0 20px' }}>
                  <Button
                    target="_blank"
                    href={`${STATIC_HOST_URL}variants/dis_asd.tsv`}
                  >
                    {' '}
                    <i className="fa fa-download" /> Download data
                  </Button>
                </div>
                <p className="text-center">
                  The use of Simons Simplex Collection (and Simons VIP) data
                  sets is limited to projects related to advancing the field of
                  autism and related developmental disorder research. Questions
                  regarding content should be directed to
                  `collections@sfari.org`.
                </p>
              </div>
            </div>
          </Col>
        </Row>
        <Row>
          <div className={s.container}>
            <VariantSearch staticParams="labels__name=asd" showFeatures="asd" />
          </div>
        </Row>
      </Grid>
    </div>
  );
}

export default withStyles(s)(DISLandingPage);
